import { pnTokenManager } from '@pn/core/services/authentication/tokenManager';
import type { IApiClient } from '@pn/core/services/http/ports';
import env from '@pn/core/utils/env';
import { makeRequest } from './apiClient';

const { PN_API_URL, PN_API_KEY } = env;

export const pnApiClient: IApiClient = {
  request: (params) =>
    makeRequest({
      baseUrl: PN_API_URL,
      tokenManager: pnTokenManager,
      extraHeaders: {
        'X-Api-Key': PN_API_KEY,
      },
      params,
    }),
};
